import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Optional heading rendered as an h3 above the children. */
  title?: ReactNode;
  children?: ReactNode;
}

const css = `
  .ew-card {
    background: #fff;
    border: 1px solid var(--ew-n-200);
    border-radius: var(--ew-r-lg);
    padding: var(--ew-s-4);
  }
  .ew-card-title {
    font: var(--ew-fw-semibold) var(--ew-fs-h3)/var(--ew-lh-snug) var(--ew-font);
    color: var(--ew-dark);
    margin: 0 0 var(--ew-s-3) 0;
  }
`;

/**
 * Standard white surface used for KPI tiles, detail summaries, and other
 * grouped content. Pulls colors, border, radius and padding from tokens.
 *
 * @example
 *   <Card title="Active PPRs"><strong>12</strong></Card>
 *   <Card><AnyContent /></Card>
 */
export default function Card({ title, className, children, ...rest }: CardProps) {
  const classes = ['ew-card', className ?? ''].filter(Boolean).join(' ');
  return (
    <>
      <style>{css}</style>
      <div className={classes} {...rest}>
        {title !== undefined && <h3 className="ew-card-title">{title}</h3>}
        {children}
      </div>
    </>
  );
}
